// Version : 1.0.0
// Author : AGALYA

import { makeApiCall } from '../../../_common/api.utils';
import { API_URL } from '../../../const';

/** ***************** update Noc Photos Start ************************/
export const nocPhotosUpdate = (updateNocPhotosData: any) => {
	const data = {
		AddNocPhotosToken: updateNocPhotosData,
	};
	const url = `${API_URL}updateNocPhotos`;
	return makeApiCall(url, data);
};
/** ***************** update Noc Photos End ************************/
